import { Tile, Text } from "@itwin/itwinui-react";
import styles from "./SandboxTile.module.css";

export const SandboxTileSkeleton = () => {
  return (
    <Tile
      className={[styles.tile, styles.tileSkeleton].join(" ")}
      name={<Text isSkeleton />}
      description={<>
        <Text isSkeleton />
        <Text isSkeleton />
      </>
      }
      metadata={<Text isSkeleton />}
      thumbnail={<Text isSkeleton />}
    />
  );
};